<template>
    <div>
        <div
            v-if="! appointments"
            class="columns is-multiline"
        >
            <SkeletonCard :count="4" />
        </div>

        <Notification v-if="appointments && ! appointments.Rows">
            No appointments found.
        </Notification>

        <div
            v-if="appointments"
            class="columns is-multiline"
        >
            <Appointment
                v-for="appointment in appointments.Rows"
                :key="appointment.AppointmentPK"
                :appointment="appointment"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Appointment from './Appointment.vue';
import Notification from './Notification.vue';
import SkeletonCard from './SkeletonCard.vue';

export default {
    components: {
        Appointment,
        Notification,
        SkeletonCard,
    },

    computed: {
        ...mapState('contactAppointments', [
            'appointments',
        ]),
    },

    mounted() {
        this.getAppointments();
    },

    methods: {
        getAppointments() {
            this.$store.dispatch('contactAppointments/getRows');
        },
    },
};
</script>
